import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import logowhite from './../../images/logo/Stargiga.png';
import { sendContactEmail } from '../../api/emailsender/EmailSender';

const FOOTER_COMPLETED_PROJECTS = [
	{ name: 'Goldcrest Views', link: '/contact-us' },
	{ name: 'Goldcrest Views 2', link: '/contact-us' },
	{ name: 'Goldcrest Executive', link: '/contact-us' },
	{ name: 'Goldcrest Dreams Tower A', link: '/goldcrest-dream-tower-a' },
	{ name: 'Goldcrest Dreams Tower B', link: '/goldcrest-dream-tower-b' },
];

const FOOTER_ONGOING_PROJECTS = [
	{ name: 'Goldcrest Dreams Tower C', link: '/goldcrest-dream-tower-c' },
	{ name: 'Goldcrest Dreams Tower D', link: '/ongoing-project' },
];

const FOOTER_DISCOVER_LINKS = [
	{ name: 'About Us', link: '/about-us' },
	{ name: 'Sustainability', link: '/sustainability' },
	{ name: 'Contact Us', link: '/contact-us' },
	{ name: 'Projects', link: '/projects' },
	{ name: 'Privacy Policy', link: '/privacy-policy' },
];

function FooterPremium() {
	const [email, setEmail] = useState('');
	const [newsletterSending, setNewsletterSending] = useState(false);
	const [newsletterMsg, setNewsletterMsg] = useState('');
	const [newsletterErr, setNewsletterErr] = useState('');

	const handleScrollTop = () => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	};

	const handleNewsletterSubmit = async (e) => {
		e.preventDefault();
		setNewsletterMsg('');
		setNewsletterErr('');
		setNewsletterSending(true);
		const result = await sendContactEmail({ email }, 'Star Giga — Newsletter signup');
		setNewsletterSending(false);
		if (result.ok) {
			setNewsletterMsg('Thank you for subscribing!');
			setEmail('');
		} else {
			setNewsletterErr(result.error);
		}
	};

	return (
		<Fragment>
			<footer className="footer-premium">
				{/* Top: Logo + Newsletter */}
				<div className="footer-premium-top">
					<div className="container">
						<div className="row align-items-center">
							<div className="col-lg-4 mb-4 mb-lg-0">
								<Link to="/" className="footer-premium-logo-link">
									<img src={logowhite} alt="Star Giga" className="footer-premium-logo" />
								</Link>
								{/* <div className="footer-premium-brand">STAR GIGA ESTABLISHMENT LTD</div> */}
							</div>
								<div className="col-lg-8 footer-premium-newsletter-right">
								<div className="footer-premium-newsletter">
									<h3 className="footer-premium-newsletter-title">STAY UPDATED</h3>
									<form onSubmit={handleNewsletterSubmit} className="footer-premium-newsletter-form">
										<input
											type="email"
											value={email}
											onChange={(e) => setEmail(e.target.value)}
											placeholder="Enter your email address*"
											className="footer-premium-newsletter-input"
											required
										/>
										<button type="submit" className="footer-premium-newsletter-btn" disabled={newsletterSending}>
											{newsletterSending ? '…' : 'SEND'}
										</button>
									</form>
									{(newsletterMsg || newsletterErr) && (
										<p className="footer-premium-newsletter-status mt-2 mb-0 small" style={{ color: newsletterErr ? '#ff6b6b' : 'rgba(255,255,255,0.85)' }}>
											{newsletterErr || newsletterMsg}
										</p>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* Main: four balanced columns */}
				<div className="footer-premium-main">
					<div className="container">
						<div className="row">
							{/* Column 1: Contact */}
							<div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
								<h4 className="footer-premium-heading">CONTACT</h4>
								<p className="footer-premium-text">Star Giga Sales Centre</p>
								<p className="footer-premium-muted">
									<a href="tel:+97167412344" className="footer-premium-link">+971 67 412 344</a>
								</p>
								<p className="footer-premium-text mt-3">Visit us</p>
								<p className="footer-premium-muted">Ajman, United Arab Emirates</p>
								<p className="footer-premium-text mt-3">General enquiries</p>
								<a href="mailto:info@stargiga.ae" className="footer-premium-link">info@stargiga.ae</a>
							</div>

							{/* Column 2: Completed projects */}
							<div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
								<h4 className="footer-premium-heading">COMPLETED PROJECTS</h4>
								<ul className="footer-premium-links">
									{FOOTER_COMPLETED_PROJECTS.map((project) => (
										<li key={`done-${project.name}`}>
											<Link to={project.link}>{project.name}</Link>
										</li>
									))}
								</ul>
							</div>

							{/* Column 3: Ongoing */}
							<div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
								<h4 className="footer-premium-heading">ONGOING PROJECTS</h4>
								<ul className="footer-premium-links">
									{FOOTER_ONGOING_PROJECTS.map((project) => (
										<li key={`ongoing-${project.link}`}>
											<Link to={project.link}>{project.name}</Link>
										</li>
									))}
								</ul>
							</div>

							{/* Column 4: Discover */}
							<div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
								<h4 className="footer-premium-heading">DISCOVER</h4>
								<ul className="footer-premium-links">
									{FOOTER_DISCOVER_LINKS.map((item) => (
										<li key={item.link + item.name}>
											<Link to={item.link}>{item.name}</Link>
										</li>
									))}
								</ul>
							</div>
						</div>
					</div>
				</div>

				{/* Bottom bar: Copyright + Social + Scroll to top */}
				<div className="footer-premium-bottom">
					<div className="container">
						<div className="row align-items-center">
							<div className="col-md-6 mb-3 mb-md-0">
								<p className="footer-premium-copyright">
									Copyright © 2026 Star Giga | Developed by{' '}
									<a
										href="https://nascentinnovations.com/"
										target="_blank"
										rel="noopener noreferrer"
										className="footer-premium-link"
									>
										Nascent Innovations
									</a>
								</p>
							</div>
							<div className="col-md-6 text-md-right">
								<div className="footer-premium-social">
									<a href="https://www.facebook.com/StarGigaUAE" target="_blank" rel="noopener noreferrer" className="footer-premium-social-icon" aria-label="Facebook">
										<i className="fa fa-facebook"></i>
									</a>
									<a href="https://x.com/stargigauae" target="_blank" rel="noopener noreferrer" className="footer-premium-social-icon" aria-label="Twitter">
										<i className="fa fa-twitter"></i>
									</a>
									<a href="https://www.linkedin.com/company/stargigauae/" target="_blank" rel="noopener noreferrer" className="footer-premium-social-icon" aria-label="LinkedIn">
										<i className="fa fa-linkedin"></i>
									</a>
									<a href="https://www.youtube.com/user/gigagroup" target="_blank" rel="noopener noreferrer" className="footer-premium-social-icon" aria-label="YouTube">
										<i className="fa fa-youtube"></i>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>

				<button type="button" className="footer-premium-scroll-top" onClick={handleScrollTop} aria-label="Scroll to top">
					<i className="fa fa-chevron-up"></i>
				</button>
			</footer>

			<style>{`
				.footer-premium {
					background-color: #0d0d0d;
					color: #fff;
					font-family: inherit;
					position: relative;
				}
				.footer-premium-top {
					padding: 20px 0 20px;
					border-bottom: 1px solid rgba(255,255,255,0.08);
				}
				.footer-premium-logo {
					max-height: 110px;
					width: auto;
					display: block;
				}
				.footer-premium-logo-link {
					display: inline-block;
					// margin-bottom: 12px;
				}
				.footer-premium-brand {
					font-size: 12px;
					letter-spacing: 0.15em;
					color: #fff;
					opacity: 0.95;
				}
				.footer-premium-newsletter-title {
					font-size: 12px;
					letter-spacing: 0.2em;
					color: #fff;
					margin-bottom: 14px;
					font-weight: 600;
				}
				.footer-premium-newsletter-right {
					display: flex;
					justify-content: flex-end; /* Desktop alignment */
				}
				@media (max-width: 991.98px) {
					.footer-premium-newsletter-right {
						justify-content: flex-start; /* Prevent flex-end pushing newsletter on mobile/tablet */
					}
				}
				.footer-premium-newsletter-form {
					display: flex;
					max-width: 480px;
					border: 1px solid white;
					border-radius: 5px;
					overflow: hidden;
					background: #fff;
				}
				.footer-premium-newsletter-input {
					flex: 1;
					border: none;
					padding: 14px 20px;
					font-size: 14px;
					color: #333;
				}
				.footer-premium-newsletter-input::placeholder {
					color: #999;
				}
				.footer-premium-newsletter-btn {
					background: #000;
					color: #fff;
					border: none;
					padding: 14px 28px;
					font-size: 12px;
					letter-spacing: 0.1em;
					font-weight: 600;
					cursor: pointer;
					transition: background 0.2s;
				}
				.footer-premium-newsletter-btn:hover {
					background: #b8975f;
				}
				.footer-premium-main {
					padding: 50px 0 40px;
				}
				.footer-premium-heading {
					font-size: 16px;
					letter-spacing: 0.2em;
					color: #fff;
					margin-bottom: 18px;
					font-weight: 600;
				}
				.footer-premium-text {
					font-size: 15px;
					color: rgba(255,255,255,0.9);
					margin-bottom: 4px;
					line-height: 1.5;
				}
				.footer-premium-muted {
					font-size: 13px;
					color: rgba(255,255,255,0.6);
					margin-bottom: 0;
					line-height: 1.5;
				}
				.footer-premium-link {
					font-size: 13px;
					color: rgba(255,255,255,0.7);
					text-decoration: none;
				}
				.footer-premium-link:hover {
					color: #fff;
				}
				.footer-premium-links {
					list-style: none;
					padding: 0;
					margin: 0;
				}
				.footer-premium-links li {
					margin-bottom: 6px;
				}
				.footer-premium-links li:last-child {
					margin-bottom: 0;
				}
				.footer-premium-links a {
					font-size: 14px;
					color: rgba(255,255,255,0.75);
					text-decoration: none;
					transition: color 0.2s;
				}
				.footer-premium-links a:hover {
					color: #fff;
				}
				.footer-premium-bottom {
					padding: 24px 0;
					border-top: 1px solid rgba(255,255,255,0.08);
				}
				.footer-premium-copyright {
					font-size: 13px;
					color: rgba(255,255,255,0.6);
					margin: 0;
				}
				.footer-premium-social {
					display: flex;
					justify-content: flex-end;
					gap: 16px;
				}
				.footer-premium-social-icon {
					color: #fff;
					font-size: 18px;
					opacity: 0.8;
					transition: opacity 0.2s;
				}
				.footer-premium-social-icon:hover {
					opacity: 1;
				}
				.footer-premium-scroll-top {
					position: fixed;
					bottom: 24px;
					right: 24px;
					width: 48px;
					height: 48px;
					border-radius: 50%;
					background: #000;
					color: #fff;
					border: none;
					cursor: pointer;
					display: flex;
					align-items: center;
					justify-content: center;
					box-shadow: 0 4px 16px rgba(0,0,0,0.3);
					z-index: 999;
					transition: transform 0.2s, background 0.2s;
				}
				.footer-premium-scroll-top:hover {
					background: #222;
					transform: translateY(-2px);
				}
			`}</style>
		</Fragment>
	);
}

export default FooterPremium;
